import { Button } from '@root/components/v3/button';
import { DialogClose, DialogFooter, DialogHeader, DialogTitle } from '@root/components/v3/dialog';
import { Label } from '@root/components/v3/label';
import { Textarea } from '@root/components/v3/textarea';
import { axiosPost } from '@root/services/axios/axiosPost';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast } from 'sonner';
const ResolvePopup = ({
  onClose,
  resolveDialogData,
  setResolveDialogData,
  bulkRemediation = false,
  previousJustification = '',
  from,
  isSelectAllEventDetails,
  isSelectAllEvent,
  setSelectEventType,
  setIsSelectAllEvent,
  environments,
  isActionHistory = false,
}) => {
  const [justification, setJustification] = useState(previousJustification);
  const [showLoader, setShowLoader] = useState(false);
  const user = useSelector(state => state.user);
  const queryClient = useQueryClient();

  const handleActionChange = async () => {
    setShowLoader(true);
    let payload;
    if (from == 'k8') {
      payload = {
        user_email: user.info.user.email,
        cluster: resolveDialogData?.cluster,
        action: 'resolve',
        image_digest: resolveDialogData?.image_digest,
        image: resolveDialogData?.image,
        rule_id: resolveDialogData?.rule_id,
        justification_time: 0,
        alert_id: resolveDialogData?.alert_id,
        justification_reason: justification,
        is_permanent: false,
        environment: environments,
        message: resolveDialogData?.message,
      };
      try {
        const res = await axiosPost('v1/kubernetes/runtime-alerts/update-action', payload, true);
        if (res) {
          setShowLoader(false);
        }
        if (res?.data && res.data.error === 0) {
          toast.success('Action updated succesfully!');
          setResolveDialogData(prev => ({ ...prev, selected: true }));
          queryClient.invalidateQueries(['get_kubernetes_runtime_alerts_list']);
          queryClient.invalidateQueries(['get_justified_events']);
          onClose();
        } else {
          toast.error('Something went wrong!');
        }
      } catch (error) {
        toast.error('Something went wrong!');
      } finally {
        onClose();
      }
    } else {
      if (bulkRemediation) {
        payload = {
          range: {
            to_date: isSelectAllEventDetails?.to_date,
            from_date: isSelectAllEventDetails?.from_date,
            timezone: isSelectAllEventDetails?.timezone,
          },
          scope: isSelectAllEventDetails?.scope,
          environments: isSelectAllEventDetails?.environments,
          cloud_provider: isSelectAllEventDetails?.cloud_provider,
          ...(isSelectAllEvent && {
            search_keyword: isSelectAllEventDetails?.search_keyword,
            event_filter: {
              all_resources: {
                service_category: isSelectAllEventDetails?.event_filter?.all_resources?.service_category,
                service: isSelectAllEventDetails?.event_filter?.all_resources?.service,
                resource_type: isSelectAllEventDetails?.event_filter?.all_resources?.resource_type,
              },
              properties_filter: {
                cve_id: isSelectAllEventDetails?.event_filter?.properties_filter?.cve_id,
                evaluation: isSelectAllEventDetails?.event_filter?.properties_filter?.evaluation,
                risk: isSelectAllEventDetails?.event_filter?.properties_filter?.risk,
                environment_tag: isSelectAllEventDetails?.event_filter?.properties_filter?.environment_tag,
                event_type: isSelectAllEventDetails?.event_filter?.properties_filter?.event_type,
                master_rule_id: isSelectAllEventDetails?.event_filter?.properties_filter?.master_rule_id,
                cq_shield_priority: isSelectAllEventDetails?.event_filter?.properties_filter?.cq_shield_priority,
                event_name: isSelectAllEventDetails?.event_filter?.properties_filter?.event_name,
                principal_arn: isSelectAllEventDetails?.event_filter?.properties_filter?.principal_arn,
                source_ip_address: isSelectAllEventDetails?.event_filter?.properties_filter?.source_ip_address,
                country: isSelectAllEventDetails?.event_filter?.properties_filter?.country,
                event_source: isSelectAllEventDetails?.event_filter?.properties_filter?.event_source,
                mitre_attack: isSelectAllEventDetails?.event_filter?.properties_filter?.mitre_attack,
                detection_risk: isSelectAllEventDetails?.event_filter?.properties_filter?.detection_risk,
                match: isSelectAllEventDetails?.event_filter?.properties_filter?.match,
                threat_action: isSelectAllEventDetails?.event_filter?.properties_filter?.threat_action,
                detected_date: {
                  start: isSelectAllEventDetails?.event_filter?.properties_filter?.detected_date.start,
                  end: isSelectAllEventDetails?.event_filter?.properties_filter?.detected_date.end,
                },
              },
            },
            threat_action: 'Resolve',
            justification_reason: justification || '',
            justification_time: 0,
            is_permanent: false,
            user: user.info.user.email,
          }),
          tab: isActionHistory ? 'action_history' : 'threat',
          is_all_events_selected: isSelectAllEvent ? true : false,
          unique_id: window.localStorage.getItem('uniqueUserId'),
          data: isSelectAllEvent
            ? []
            : resolveDialogData?.map(data => {
                return {
                  event_id: data.event_id,
                  environment_id: data.environment_id,
                  master_rule_id: data.master_rule_id,
                  principal_arn: data.principal_arn,
                  justification_reason: justification,
                  event_name: data.event_name,
                  justification_time: 0,
                  justification_active: false,
                  is_permanent: false,
                  threat_action: 'Resolve',
                  user: user.info.user.email,
                  source_ips: data?.ips && data?.ips[0] ? data?.ips[0] : '',
                };
              }),
        };
      } else {
        payload = {
          range: {
            to_date: isSelectAllEventDetails?.to_date,
            from_date: isSelectAllEventDetails?.from_date,
            timezone: isSelectAllEventDetails?.timezone,
          },
          scope: isSelectAllEventDetails?.scope,
          environments: isSelectAllEventDetails?.environments,
          cloud_provider: isSelectAllEventDetails?.cloud_provider,
          tab: isActionHistory ? 'action_history' : 'threat',
          is_all_events_selected: false,
          unique_id: window.localStorage.getItem('uniqueUserId'),
          data: [
            {
              event_id: resolveDialogData.event_id,
              environment_id: resolveDialogData.environment_id,
              master_rule_id: resolveDialogData.master_rule_id,
              principal_arn: resolveDialogData.principal_arn,
              justification_reason: justification,
              event_name: resolveDialogData.event_name,
              justification_time: 0,
              justification_active: false,
              is_permanent: false,
              threat_action: 'Resolve',
              user: user.info.user.email,
              source_ips: resolveDialogData?.ips && resolveDialogData?.ips[0] ? resolveDialogData?.ips[0] : '',
            },
          ],
        };
      }

      try {
        const res = await axiosPost('cloud_events_1.2/event_action_update', payload);
        if (res) {
          setShowLoader(false);
        }

        if (res?.data && !res?.data.error) {
          toast.success(res?.data?.message);

          if (bulkRemediation) {
            setResolveDialogData(prev => {
              return prev?.map(data => ({
                ...data,
                selected: 'Resolve',
              }));
            });
          } else {
            setResolveDialogData(prev => ({ ...prev, selected: true }));
          }
          queryClient.invalidateQueries(['get_list_events_threats']);
          if (isActionHistory) {
            queryClient.invalidateQueries(['get_justified_events']);
          }
          onClose();
        } else {
          toast.error('Something went wrong!');
        }
      } catch (error) {
        toast.error('Something went wrong!');
      } finally {
        setSelectEventType('');
        setIsSelectAllEvent(false);
        onClose();
      }
    }
  };

  const handleChange = e => {
    const inputValue = e.target.value;
    if (inputValue.length <= 300) {
      setJustification(() => inputValue);
    } else {
      setJustification(() => inputValue.substring(0, 300));
    }
  };

  return (
    <>
      <DialogHeader>
        <DialogTitle className="text-[#1a202c] text-sm font-semibold">Resolve Finding</DialogTitle>
      </DialogHeader>

      <div className="">
        <div className="text-[#484d56] font-manrope text-xs font-medium flex">
          <Label className="!text-[12px]">Justification</Label>
          <div className="hidden">
            <span className="text-[#F84D4D]">*</span>Max 300 words
          </div>
        </div>

        <Textarea
          placeholder="Ensure your reason is in 30-300 characters"
          value={justification}
          onChange={handleChange}
          autoFocus
        />

        <div className="mt-[15px] text-xs font-medium text-[#484d56]">
          <span className="text-[#F84D4D]">* Minimum 30 &/or Maximum 300 characters allowed</span>
        </div>
      </div>

      <DialogFooter className="gap-[15px] py-0">
        <DialogClose asChild>
          <Button
            data-testid="click-events-table-resolvepopup"
            data-clickable="true"
            variant="outline"
            onClick={onClose}>
            Cancel
          </Button>
        </DialogClose>
        <Button
          disabled={justification.length < 30 || justification.length > 300}
          data-testid="click-events-table-resolvepopup"
          data-clickable="true"
          onClick={showLoader ? () => {} : handleActionChange}>
          {showLoader && <Spinner animation="border" size="sm" />}
          Submit
        </Button>
      </DialogFooter>
    </>
  );
};

export default ResolvePopup;
